/**
 * Path of the 404 page (/404.html): static hosts serve it for unknown URLs. It's TanStack Start's SPA shell (see
 * vite.config.ts), so the client renders the not-found page for the actual URL, without hydration mismatches.
 */
export const notFoundShellPath = '/404';

/** Site-wide metadata, the counterpart of Gatsby's `siteMetadata` (gatsby-config.ts in the old project). */
export const siteMetadata = {
  title: 'Pixwrist',
  description:
    'Motivációs karkötők színes mintával és inspiráló üzenettel. Találd meg a Hozzád illőt!',
  image: '/images/pixwrist-logo.png', // placed in the 'public' folder
  siteUrl: 'https://www.pixwrist.hu', // no trailing slash (the sitemap uses it too, see vite.config.ts)
  locale: 'hu_HU',
  themeColor: '#FFF',
  email: 'pixwrist@pixwrist.hu',
  socialProfiles: [
    'https://www.instagram.com/pixwrist',
    'https://www.tiktok.com/@pixwrist',
    'https://www.facebook.com/pixwrist'
  ]
};
